// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root___wAPg","dragIcon":"SortableItem_dragIcon__1QhWc","disabled":"SortableItem_disabled__1Pq9e"};